// extracted by mini-css-extract-plugin
export default {"palletsSummary":"PalletsSummaryWithTotalPriceAndAmount_palletsSummary__PQKpn","palletsSummaryDivider":"PalletsSummaryWithTotalPriceAndAmount_palletsSummaryDivider__DXSz0"};